export const BASE_URL =
  "https://gmtechnology.com.co/backend_restaurante_carta/";
export const limitebusqueda = 5;
